import React from 'react';
import { EventFormStore } from 'stores/events/event-form-store';
import { IdentityService } from 'services/identity-service';
import EventCreateButtonTw from './buttons/event-create-button-tw';
import EventCancelPreviewButtonTw from './buttons/event-cancel-preview-button-tw';
import EventMergeButtonTw from './buttons/event-merge-button-tw';
import EventCancelMergeButtonTw from './buttons/event-cancel-merge-button-tw';
import EventNextStatusButtonTw from './buttons/event-next-status-button-tw';
import EventValidateButtonTw from './buttons/event-validate-button-tw';
import EventEditPocButtonTw from './buttons/event-edit-poc-button-tw';
import EventEditButtonTw from './buttons/event-edit-button-tw';
import EventCancelEventButtonTw from './buttons/event-cancel-event-button-tw';
import EventRequestChangesButtonTw from './buttons/event-request-changes-button-tw';
import EventPreviousStatusButtonTw from './buttons/event-previous-status-button-tw';
import CloseButtonTw from 'site/pages/events/event-form/buttons/close-button-tw';

interface BottomToolbarActionsEventsProps {
  eventFormStore: EventFormStore;
  identityService: IdentityService;
  mode: string;
  readOnly: boolean;
  readOnlyForPocs: boolean;
  sidebarWidthPx?: number;

  // callbacks para acciones
  onPreviousStatus?: () => void;
  onRequestChanges?: () => void;
  onCancelEvent?: () => void;
  onEdit?: () => void;
  onSave?: () => void;
  onValidate?: () => void;
  onNextStatus?: () => void;
  onCloseEvent?: () => void;
  onCancel?: () => void;
  onMerge?: () => void;
  onCreate?: () => void;
}

const BottomToolbarActionsEvents: React.FC<BottomToolbarActionsEventsProps> = ({
  eventFormStore,
  identityService,
  mode,
  readOnly,
  readOnlyForPocs,
  sidebarWidthPx = 56,
  onPreviousStatus,
  onRequestChanges,
  onCancelEvent,
  onEdit,
  onSave,
  onValidate,
  onNextStatus,
  onCloseEvent,
  onCancel,
  onMerge,
  onCreate
}) => {
  return (
    <div
      className="fixed bottom-0 border-t border-gray-300 bg-white px-2 py-2 shadow-lg"
      style={{
        zIndex: 100,
        left: sidebarWidthPx,
        width: `calc(100% - ${sidebarWidthPx}px)`
      }}
    >
      <div className="flex flex-wrap gap-2 w-full justify-between">
        {mode === 'ViewDetails' && (
          <>
            <EventPreviousStatusButtonTw eventFormStore={eventFormStore} readOnly={readOnly} onPreviousStatus={onPreviousStatus} />

            <EventRequestChangesButtonTw
              eventFormStore={eventFormStore}
              identityService={identityService}
              readOnly={readOnly}
              onRequestChanges={onRequestChanges}
            />

            <EventCancelEventButtonTw eventFormStore={eventFormStore} readOnly={readOnly} onCancelEvent={onCancelEvent} />

            <EventEditButtonTw eventFormStore={eventFormStore} readOnly={readOnly} onEdit={onEdit} onSave={onSave} />

            <EventEditPocButtonTw eventFormStore={eventFormStore} readOnlyForPocs={readOnlyForPocs} onEdit={onEdit} onSave={onSave} />

            <EventValidateButtonTw
              eventFormStore={eventFormStore}
              identityService={identityService}
              readOnly={readOnly}
              onValidate={onValidate}
            />

            <EventNextStatusButtonTw eventFormStore={eventFormStore} readOnly={readOnly} onNextStatus={onNextStatus} />

            <CloseButtonTw eventFormStore={eventFormStore} readOnly={readOnly} onClosed={onCloseEvent} />
          </>
        )}

        {mode === 'Merge' && (
          <>
            <EventCancelMergeButtonTw onCancel={onCancel} />
            <EventMergeButtonTw onMerge={onMerge} />
          </>
        )}

        {mode === 'Preview' && (
          <>
            <EventCancelPreviewButtonTw onCancel={onCancel} />
            <EventCreateButtonTw onCreate={onCreate} />
          </>
        )}
      </div>
    </div>
  );
};

export default BottomToolbarActionsEvents;
